import "./App.css";
import "./components/LandingPageV2.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LandingPage } from "./components/LandingPage";
import { FAQPage } from "./components/FAQPage";
import { UploadPage } from "./components/upload";
import { TenderProcessPage } from "./components/TenderProcessPage";
import { SuccessPage } from "./components/SuccessPage";
import { CancelPage } from "./components/CancelPage";
import { TermsPage } from "./components/TermsPage";
import { ContactPage } from "./components/ContactPage";
import { ConfirmationPage } from "./components/ConfirmationPage";
import { AdminDashboard } from "./components/AdminDashboard";
import { IndicativeTool } from "./components/IndicativeTool";
import { DetailedTool } from "./components/DetailedTool";
import ScopePage from "./components/ScopePage";
import { ScopeDrawPage } from "./components/ScopeDrawPage";
import { ScopeSuccessPage } from "./components/ScopeSuccessPage";
import { ClientPortal } from "./components/ClientPortal";
import PricingPage from "./components/PricingPage";
import SharedSowPage from "./components/SharedSowPage";
import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from "./components/AuthPages";
import DashboardPage from "./components/DashboardPage";
import VerifyEmailPage from "./components/VerifyEmailPage";
import { AuthProvider } from "./contexts/AuthContext";
import { SiteModeProvider } from "./contexts/SiteModeContext";
import { SiteGate, HomeRoute } from "./components/founding/SiteGate";
import FoundingMemberPage from "./components/founding/FoundingMemberPage";
import TesterLoginPage from "./components/founding/TesterLoginPage";
import UnsubscribePage from "./components/founding/UnsubscribePage";
import PrivacyPage from "./components/PrivacyPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteModeProvider>
        <AuthProvider>
          <SiteGate>
          <Routes>
            <Route path="/" element={<HomeRoute landing={<LandingPage />} founding={<FoundingMemberPage />} />} />
            <Route path="/testing" element={<TesterLoginPage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/estimate" element={<IndicativeTool />} />
            <Route path="/estimate/success" element={<ScopeSuccessPage />} />
            <Route path="/scope" element={<ScopePage />} />
            <Route path="/scope-legacy" element={<DetailedTool />} />
            <Route path="/scope/draw" element={<ScopeDrawPage />} />
            <Route path="/tender-process" element={<TenderProcessPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/confirmation" element={<ConfirmationPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/account" element={<Navigate to="/dashboard" replace />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/share/sow/:token" element={<SharedSowPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            {/* Catch-all route - redirect unknown paths to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </SiteGate>
        </AuthProvider>
        </SiteModeProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
